import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AppAuthGuard } from './app.authguard';
import {SentTrayComponent} from './sent-tray/sent-tray.component';
import {UploadComponent} from './upload/upload.component';
import { EditComponent } from './edit/edit.component';

const routes: Routes = [
 
  
  {
    path: 'tray',
    component: SentTrayComponent,
    canActivate: [AppAuthGuard]
  },
  {
    path: 'uploader',
    component: UploadComponent,
    canActivate: [AppAuthGuard]
  },
  {
    path: 'edit',
    component: EditComponent,
    canActivate: [AppAuthGuard]
  },
  {
    path: '',
    component: SentTrayComponent,
    canActivate: [AppAuthGuard]
  }
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class AppRoutingModule {}